<div
  class="bottom-footer footer-casino"
  id="footerId"
  *ngIf="!isMoblileView"
  [class.is-revealed]="isfooterBarOpen"
  (mouseenter)="onFooterEnter()"
  (mouseleave)="onFooterLeave()">
  <div class="footer-casino__handle" aria-hidden="true"></div>
  <div class="footer-casino__inner">
    <nav class="footer-nav" aria-label="Account">
      <a
        class="footer-nav__link"
        routerLink="MyAccount"
        routerLinkActive="active"
        (click)="onOpenLink()"
        *ngIf="isLoggedIn">
        <span class="footer-nav__dot"></span>
        <span>My Account</span>
      </a>
      <a
        class="footer-nav__link"
        routerLink="SignUpHost"
        routerLinkActive="active"
        (click)="onOpenLink()"
        *ngIf="isLoggedIn">
        <span class="footer-nav__dot"></span>
        <span>Sign-Up to Host</span>
      </a>
      <a
        class="footer-nav__link"
        routerLink="HostPortal"
        routerLinkActive="active"
        (click)="onOpenLink()"
        *ngIf="isLoggedIn && isHost">
        <span class="footer-nav__dot"></span>
        <span>Host Portal</span>
      </a>
      <a
        class="footer-nav__link"
        routerLink="OwnerPortal"
        routerLinkActive="active"
        (click)="onOpenLink()"
        *ngIf="isLoggedIn && isOwner">
        <span class="footer-nav__dot"></span>
        <span>Owner's Portal</span>
      </a>
    </nav>

    <a class="footer-casino__brand" routerLink="/Webinar-rooms" aria-label="LootLucky home">
      <span class="footer-brand-logo clsFooterLogo">
        <img src="assets/Images/logo_image.png" alt="" class="footer-brand-logo-icon" />
        <img src="assets/Images/logo_text.png" alt="LootLucky" class="footer-brand-logo-text" />
      </span>
      <span class="clsFooterText">World of Webinars Company</span>
    </a>
  </div>
</div>

<div class="mobileVIewBottomIcons" *ngIf="isMoblileView">
  <div class="mobile-footer-leading">
    <div class="footer-icon" matTooltip="Webinar Rooms">
      <mat-icon routerLink="Webinar-rooms" (click)="onOpenLink()">home</mat-icon>
    </div>
    <div class="footer-icon" matTooltip="My Account" *ngIf="isLoggedIn">
      <mat-icon routerLink="MyAccount" (click)="onOpenLink()">account_circle</mat-icon>
    </div>
    <div class="footer-icon" matTooltip="Go To Top">
      <mat-icon (click)="goToTop()">arrow_circle_up</mat-icon>
    </div>
    <div class="footer-icon" matTooltip="Menus">
      <mat-icon (click)="onHoverOnList()" *ngIf="isLoggedIn">lists</mat-icon>
    </div>
  </div>
  <div class="footer-icon footer-icon--brand-edge" matTooltip="LootLucky">
    <div class="footer-brand-stack footer-brand-stack--mobile">
      <span class="mobile-footer-brand-logo clsMobileFooterLogo" aria-label="LootLucky">
        <img src="assets/Images/logo_image.png" alt="" class="mobile-footer-brand-logo-icon" />
        <img src="assets/Images/logo_text.png" alt="LootLucky" class="mobile-footer-brand-logo-text" />
      </span>
      <span class="clsMobileFooterText">World of Webinars Company</span>
    </div>
  </div>

  <div *ngIf="isShowLMenu && isMoblileView" class="mobileViewMenuList">
    <nav class="footer-nav footer-nav--overlay" aria-label="More">
      <a
        class="footer-nav__link"
        routerLink="SignUpHost"
        routerLinkActive="active"
        (click)="onOpenLink()"
        *ngIf="isLoggedIn">
        <span class="footer-nav__dot"></span>
        <span>Sign-Up to Host</span>
      </a>
      <a
        class="footer-nav__link"
        routerLink="HostPortal"
        routerLinkActive="active"
        (click)="onOpenLink()"
        *ngIf="isLoggedIn && isHost">
        <span class="footer-nav__dot"></span>
        <span>Host Portal</span>
      </a>
      <a
        class="footer-nav__link"
        routerLink="OwnerPortal"
        routerLinkActive="active"
        (click)="onOpenLink()"
        *ngIf="isLoggedIn && isOwner">
        <span class="footer-nav__dot"></span>
        <span>Owner's Portal</span>
      </a>
    </nav>
  </div>
</div>
